import { graphql, useStaticQuery } from 'gatsby';

export interface StoryblokLink {
  id: string;
  name: string;
  slug: string;
  parent_id: string | null;
}

export const useStoryblokLinks = (): StoryblokLink[] => {
  const data = useStaticQuery(graphql`
    query {
      allStoryblokLink {
        nodes {
          id
          name
          slug
          parent_id
        }
      }
    }
  `);

  return data.allStoryblokLink.nodes;
};
